import React, { useEffect, useState } from "react";
import {
  AiFillMinusCircle,
  AiFillPlusCircle,
  AiOutlineCheckCircle,
} from "react-icons/ai";
import { BiHighlight } from "react-icons/bi";
import { FaConciergeBell } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { router } from "../../Constants.js";
import Button from "../../components/Button";
import Input from "../../components/Input";
import Loading from "../../components/Loading";
import Navbar from "../../components/Navbar";
import { onSave } from "../../config/config";
import { setKeranjang, setOrder } from "../../redux/actions/prepareActions";
import api from "../../request";
import FormatPhone from "../../utils/FormatPhone";
import { decrypt, encrypt } from "../../utils/enkripsi";
import { formatDate, formatMinutes } from "../../utils/formatDate";
import formatterMoney from "../../utils/formatMoney";
import { showLog } from "../../utils/log.js";
import { onHitung as hitung } from "../../utils/onHitung";
import { socket } from "../../utils/socket";

export default function DetailOrder() {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  let navigate = useNavigate();
  const [dataOrder, setDataOrder] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [loadingPembayaran, setLoadingPembayaran] = React.useState(false);
  const [detailPembayaran, setDetailPembayaran] = React.useState([]);
  const [dataorderan, setDataOrderan] = React.useState();
  const [isMenu, setisMenu] = useState(false);
  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
  };
  const [isMenuSubMenu, setMenuSubMenu] = useState(true);
  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === true ? false : true);
  };
  let boxClass = ["main-menu menu-right menuq1"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }
  var date = new Date();
  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;
  var today = year + "-" + month + "-" + day;
  var d = new Date();
  let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
  let minutes = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
  var n = hours + ":" + minutes;
  const [detailUsers, setDetailUsers] = React.useState({
    nama: "",
    email: "",
    nomerHp: "",
    date: today,
    time: n,
  });

  async function onHitung() {
    showLog("DetailOrder Masuk onHitung");
    const dataOrder = decrypt(JSON.parse(localStorage.getItem("pesanan")));
    const pesanan = dataOrder.map((item) => ({
      qty: item.item,
      price: item.price || item.harga,
    }));
    const s = hitung(pesanan);
    let sub_total = [];
    sub_total.push({
      label: "Subtotal",
      value: s?.data?.sub_total,
    });
    for (const x of s.chargeNotes) {
      sub_total.push({
        label: x.id + " " + x.percent_value + "%",
        value: x.value,
      });
    }
    sub_total.push({
      label: "Total Pembayaran",
      value: s?.data?.grand_total_net,
    });
    setDetailPembayaran(sub_total);
  }

  function onPressMinus(data) {
    showLog("DetailOrder Masuk onPressMinus");
    const pesanan = decrypt(JSON.parse(localStorage.getItem("pesanan")));
    if (data["product_id"]) {
      const selectPesanan = pesanan.filter(
        (items) => items["product_id"] == data["product_id"]
      );
      data.item -= 1;
      for (const xi of selectPesanan) {
        if (xi["item"] > 0) {
          xi["item"] -= 1;
          xi["total"] -= data["price"] || data["harga"];
        }
      }
    }
    if (data["name"]) {
      const selectPesananPaket = pesanan.filter(
        (items) => items["product"] == data["product"]
      );
      data.item -= 1;
      for (const xi of selectPesananPaket) {
        if (xi["item"] > 0) {
          xi["item"] -= 1;
          xi["total"] -= data["harga"];
        }
      }
    }
    if (data.item < 1) {
      let dataLocal = decrypt(JSON.parse(localStorage.getItem("pesanan")));
      let getData = dataLocal.filter(
        (item) =>
          item["product_id"] !== data["product_id"] ||
          item["name"] !== data["name"]
      );
      const deletPesanan = pesanan.filter(
        (items) =>
          items["product_id"] !== data["product_id"] ||
          items["name"] !== data["name"]
      );
      localStorage.setItem("pesanan", JSON.stringify(encrypt(deletPesanan)));
      setDataOrder(getData);
      dispatch(setKeranjang());
      onHitung();
      if (getData.length == 0) {
        navigate(`${router}/order`);
      }
      return;
    }
    localStorage.setItem("pesanan", JSON.stringify(encrypt(pesanan)));
    setDataOrder(pesanan);
    dispatch(setKeranjang());
    onHitung();
  }

  function onPressPlus(data) {
    showLog("DetailOrder Masuk onPressPlus");
    const pesanan = decrypt(JSON.parse(localStorage.getItem("pesanan")));
    if (data["product_id"]) {
      const selectPesanan = pesanan.filter(
        (items) => items["product_id"] == data["product_id"]
      );
      data.item += 1;
      for (const xi of selectPesanan) {
        xi["item"] += 1;
        xi["total"] += data["price"];
      }
    }
    if (data["name"]) {
      const selectPesananPaket = pesanan.filter(
        (items) => items["name"] == data["name"]
      );
      data.item += 1;
      for (const xi of selectPesananPaket) {
        xi["item"] += 1;
        xi["total"] += data["harga"];
      }
    }
    localStorage.setItem("pesanan", JSON.stringify(encrypt(pesanan)));
    setDataOrder(pesanan);
    onHitung();
  }

  async function refreshDataOrder() {
    showLog("DetailOrder Masuk refreshDataOrder");
    let data = localStorage.getItem("pesanan");
    if (data == null) {
      setDataOrder([]);
      data = [];
    } else {
      data = decrypt(JSON.parse(data));
      for (const x of data) {
        x["selection"] = false;
      }
      setDataOrder(data);
    }
    setLoading(false);
    onHitung();
  }

  useEffect(() => {
    showLog("DetailOrder Masuk useEffect 1");
    refreshDataOrder();
    const users = JSON.parse(localStorage.getItem("login"));
    const orderDate = JSON.parse(localStorage.getItem("orderDate"));
    if (users && !orderDate) {
      setDetailUsers((val) => ({
        ...val,
        nama: users.nama,
        nomerHp: FormatPhone(users.telp),
        email: "",
      }));
    }
    if (orderDate) {
      setDetailUsers((val) => ({
        ...val,
        nama: orderDate.nama,
        nomerHp: FormatPhone(orderDate.nomerHp),
        email: orderDate.email,
        date: orderDate.date,
        time: orderDate.time,
      }));
    }
  }, []);

  useEffect(() => {
    showLog("DetailOrder Masuk useEffect 2");

    const handleConnect = () => {
      showLog(`Socket Connected With ID = ${socket.id}`);
    };

    const handleConnectError = (err) => {
      showLog(`Socket Connect Error ${err}`);
    };

    const handleCallKitchen = async (data) => {
      showLog("Socket Call Kitchen");
      const branch = JSON.parse(localStorage.getItem("dataBranch"));
      let dataorder = [];
      dataorder = await api.apiPrepare.get({ id: branch.detailData });
      setDataOrderan(dataorder.data);
    };

    socket.on("connect", handleConnect);
    socket.on("connect_error", handleConnectError);
    socket.on("call-kitchen", handleCallKitchen);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("connect_error", handleConnectError);
      socket.off("call-kitchen", handleCallKitchen);
    };
  }, []);

  async function onOrder() {
    showLog("DetailOrder Masuk onOrder");
    setLoadingPembayaran(true);
    const userServer = localStorage.getItem("userServer");
    // if (detailUsers['nomerHp'] == '' && !localStorage.getItem('login')) {
    if (false) {
      setLoadingPembayaran(false);
      addToast("No Telepon harus diisi", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    } else {
      let detailTrans = [];
      const pesanan = decrypt(JSON.parse(localStorage.getItem("pesanan")));
      const branch = JSON.parse(localStorage.getItem("dataBranch"));
      const coa = await api.apiPrepare.coaBranchAll({
        userId: detailUsers.nama == "" ? "Admin" : detailUsers.nama,
      });
      // const time = Math.random() *2000
      // await new Promise(resolve => setTimeout(resolve, time));
      // orderDate = await api.apiPrepare.get({ "id": branch.detailData })
      // let orderPrev = []
      // if(dataorderan == undefined){
      //     for(const xi of orderDate.data){
      //     orderPrev.push(xi)
      //     }
      // }
      // else{
      //     for(const xi of dataorderan){
      //     orderPrev.push(xi)
      //     }
      // }
      // for(const xii of pesanan){
      //     orderPrev.push(xii)
      // }
      const x = pesanan.map((item) => ({
        qty: item.item,
        price: item.price,
      }));
      var s = hitung(x);
      let date = {
        date: formatDate(new Date()),
        time: formatMinutes(new Date()),
      };
      // const timestamp = new Date().toISOString();
      // let a = {
      //     date: formatDate(new Date(timestamp)),
      //     time: formatMilliSeconds(new Date(timestamp))
      // };
      for (const items of pesanan) {
        detailTrans.push(
          detailTrens(items, detailUsers, branch, coa.data[0], date)
        );
      }
      const dataDetailData = {
        branch_id: branch.branchID,
        grand_total_nett: s?.data.grand_total_net,
        total: s?.data.sub_total,
        sub_total: s?.data.sub_total,
        grand_total: s?.data.grand_total,
        kembali: 0,
        payment_cash_coa: coa.data["0"]["coa_cash"],
        payment_cash_coa_name: coa.data["0"]["coa_cash_name"],
        payment_cash_value: 0,
        payment_type: 0,
        payment_others_name: "",
        payment_others_value: 0,
        payment_others_edc: "",
        payment_others_coa: "",
        dp_so: 0,
        coa_dp_so: coa.data["0"]["coa_dp_so"],
        coa_dp_so_name: coa.data["0"]["coa_dp_so_name"],
      };
      dataDetailData.id = branch.detailData;
      dataDetailData.charges_value = 0;
      // socket.emit('call-kitchen', {
      //     branch_id   : dataDetailData.branch_id,
      //     userServer  : userServer,
      //     id          : dataDetailData.id,
      //     detailData  : dataDetailData,
      //     detailTrans : detailTrans
      // });
      localStorage.setItem(
        "detailData",
        JSON.stringify(encrypt(dataDetailData))
      );
      localStorage.setItem("dataBranch", JSON.stringify(branch));
      localStorage.setItem("detailTrans", JSON.stringify(encrypt(detailTrans)));
      localStorage.setItem("chargesNote", JSON.stringify(encrypt([])));
      await onRefresh(detailTrans);
      // await new Promise(resolve => setTimeout(resolve, 1000));
      const result = await onSave("save");
      if (result.status == "OK") {
        detailUsers["nomerHp"] = "+62" + detailUsers["nomerHp"];
        localStorage.setItem("orderDate", JSON.stringify(detailUsers));
        navigate(`${router}/transaksi-proses`);
        dispatch(setOrder());
        dispatch(setKeranjang());
        localStorage.removeItem("pesanan");
      } else {
        addToast(result.message, {
          appearance: "error",
          autoDismiss: true,
        });
      }
      setLoadingPembayaran(false);
      socket.emit("call-kitchen", {
        branch_id: dataDetailData.branch_id,
        userServer: userServer,
        id: dataDetailData.id,
        detailData: dataDetailData,
        detailTrans: detailTrans,
      });
    }
  }

  function detailTrens(items, orderDate, branch, detailData, date) {
    showLog("DetailOrder Masuk detailTrens");
    return {
      product_id: items["product_id"],
      warehouse_id: detailData["default_warehouse_id"],
      coa_inv: branch.coa_inv,
      coa_sales: branch.coa_sales_inv,
      name: items.product_name
        ? items.product_name
        : items.name
          ? items["name"]
          : "",
      qty: items.item ? items.item : items.qty ? items["qty"] : 0,
      unit_id: "PCS",
      qty_unit: 1,
      unit_id_small: "PCS",
      curr: "IDR",
      rate: 1,
      price: items["price"],
      detail_disc1: 0,
      detail_disc2: 0,
      detail_disc_value: 0,
      detail_note: items["note"] ? items.note : "",
      total: items["total"],
      indent: 0,
      picpath1_thumb: items["picpath1_thumb"],
      ordered_by: orderDate["nama"] == "" ? "Admin" : orderDate["nama"],
      ordered_at: date.date + " " + date.time,
      accepted_rejected_by: "",
      accepted_rejected_note: "Chrome",
      accepted_rejected_at: null,
      prepared_by: items.prepared_by ? items.prepared_by : "",
      prepared_at: items.prepared_at ? items.prepared_at : "",
      kitchen_type_id: items.kitchen_type_id,
      promo_name: items["product_name"],
      promo_qty: items["item"],
      promo_price: items["price"],
      promo_paket: 0,
      dtp_bkp: 1,
      expired: "0000-00-00",
      price_show: items["price"],
      quantity: items["qty"],
    };
  }

  dataOrder.sort((a, b) => {
    if (a.total !== b.total) {
      return a.total - b.total;
    }
    return a.product_name.localeCompare(b.product_name);
  });

  async function onRefresh(detailTrans) {
    showLog("DetailOrder Masuk onRefresh");
    const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
    const result = await api.apiPrepare.getOrder({
      id: orderDate.detailData,
    });
    result.data = [...result.data, ...detailTrans];
    const x = hitung(result.data);
    localStorage.setItem("chargesNote", JSON.stringify(encrypt(x.chargeNotes)));
  }

  return (
    <div>
      <Navbar urlBack="/" type="back" label="Konfirmasi Pesanan" />
      <div style={{ backgroundColor: "#F0F0F0" }}>
        <div
          style={{
            padding: "7% 0 20px 0",
            display: "flex",
            margin: "0 10px 0 10px",
          }}
        >
          <FaConciergeBell color="#5451D6" size={25} />
          <div style={{ marginLeft: 20 }}>
            <div className="fonts700" style={{ fontSize: 15 }}>
              {JSON.parse(localStorage.getItem("dataBranch")).branchName}
            </div>
            <div
              className="fonts400"
              style={{ fontSize: 12, color: "#7E7E7E" }}
            >
              {JSON.parse(localStorage.getItem("dataBranch")).branchAddress}
            </div>
            <div className="fonts600" style={{ fontSize: 12 }}>
              {"ID : " +
                JSON.parse(
                  localStorage.getItem("dataBranch")
                ).detailData.substring(0, 6)}
            </div>
          </div>
        </div>
      </div>
      <div style={{ margin: "20px 10px 0 10px" }}>
        {/* {
                    !JSON.parse(localStorage.getItem('login')) &&
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px'}}>
                        <Button color="#fff" backgroundColor="#5451D6" onClick={() => { navigate(`${router}/login`)}}>Masuk</Button>
                        <Gap width={20} />
                        <Button color="#fff" backgroundColor="#5451D6" onClick={() => { navigate(`${router}/register`)}}>Daftar</Button>
                    </div>
                } */}
        {!localStorage.getItem("login") && (
          <div style={{ margin: "20px 10px", borderRadius: 5 }}>
            {/* <Input onBlur={() => {
                            localStorage.setItem('orderDate', JSON.stringify(detailUsers))
                        }} value={detailUsers['nama']} 
                        onChange={(val) => setDetailUsers((old) => ({
                            ...old,
                            nama: val.target.value
                        }))} 
                        placeholder="Nama" label="Nama" />
                        <Gap height={10} /> */}
            {/* <Input onBlur={() => {
                            if (validateEmail(detailUsers)) {
                                localStorage.setItem('orderDate', JSON.stringify(detailUsers))
                            }
                            else {
                                addToast("Email salah", {
                                    appearance: 'error',
                                    autoDismiss: true,
                                })
                                setDetailUsers((old) => ({
                                    ...old,
                                    email: ""
                                }))
                            }
                        }} value={detailUsers['email']} 
                        onChange={(val) => setDetailUsers((old) => ({
                            ...old,
                            email: val.target.value
                        }))} 
                        placeholder="example@mail.com" label="Email" />
                        <Gap height={10} /> */}
            {/* <InputPhone onBlur={() => {
                            localStorage.setItem('orderDate', JSON.stringify(detailUsers))
                        }} value={detailUsers['nomerHp']} onChange={(val) => setDetailUsers((old) => ({
                            ...old,
                            nomerHp: val
                        }))} placeholder="8123456789" label="Nomor Handphone" /> */}
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "0px 10px 0px 10px",
          }}
        >
          <div className="fonts500">Pesanan</div>
          <div>
            <Button
              onClick={() => navigate(`${router}/order`)}
              color="#fff"
              backgroundColor="#5451D6"
            >
              Tambah Pesanan
            </Button>
          </div>
        </div>
        <div
          style={{
            margin: "20px 10px 0 10px",
            backgroundColor: "#fff",
            borderRadius: 5,
          }}
        >
          {dataOrder &&
            dataOrder.map((items, index) => {
              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 0 10px 0",
                    margin: "0px 10px 0px 10px",
                    borderBottom: "1px solid #BFBFBF",
                  }}
                >
                  <div>
                    {items["name"] ? (
                      <div className={boxClass.join(" ")}>
                        <div
                          onClick={toggleSubmenu}
                          className="menu-item sub__menus__arrows "
                        >
                          <b>
                            {items["item"]}x {items["name"]}{" "}
                          </b>{" "}
                          <FiChevronDown />
                          {isMenuSubMenu && (
                            <ul className={boxClassSubMenu.join(" ")}>
                              <li
                                onClick={toggleClass}
                                activeClassName="is-active"
                              >
                                {items["product2"]}{" "}
                              </li>
                              <li
                                onClick={toggleClass}
                                activeClassName="is-active"
                              >
                                {items["product"]}{" "}
                              </li>
                            </ul>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="fonts700">
                        {items["item"]}x{" "}
                        {items["product_name"]
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ")}{" "}
                        (@ Rp{formatterMoney(items["price"])})
                      </div>
                    )}
                    {items["selection"] ? (
                      <Input
                        value={items["note"]}
                        onChange={(val) => {
                          let newArr = [...dataOrder];
                          newArr[index]["note"] = val.target.value;
                          setDataOrder(newArr);
                        }}
                      />
                    ) : (
                      <div
                        className="fonts500"
                        style={{ fontSize: 14, color: "#BFBFBF" }}
                      >
                        {items["note"]}
                      </div>
                    )}
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <AiFillMinusCircle
                        onClick={() => onPressMinus(items)}
                        color="#5451D6"
                        size={20}
                      />
                      <span
                        style={{
                          paddingRight: "10px",
                          paddingLeft: "10px",
                          fontWeight: "700",
                        }}
                      >
                        {items["item"]}
                      </span>
                      <AiFillPlusCircle
                        onClick={() => onPressPlus(items)}
                        color="#5451D6"
                        size={20}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="fonts700">
                      Rp{formatterMoney(items["total"])}
                    </div>
                    <div
                      onClick={() => {
                        let newArr = [...dataOrder];
                        for (const x of newArr) {
                          if (
                            x["product_id"] == items["product_id"] ||
                            x["name"] == items["name"]
                          ) {
                            if (items["selection"]) {
                              x["selection"] = false;
                            } else {
                              x["selection"] = true;
                            }
                          } else {
                            x["selection"] = false;
                          }
                        }
                        if (!items["selection"]) {
                          localStorage.setItem(
                            "pesanan",
                            JSON.stringify(encrypt(newArr))
                          );
                        }
                        setDataOrder(newArr);
                      }}
                      style={{
                        paddingTop: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {items["selection"] ? (
                        <AiOutlineCheckCircle size={20} />
                      ) : (
                        <BiHighlight size={20} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          {detailPembayaran.map((items, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "0px 0 0px 0",
                margin: "0px 10px 0px 10px",
                borderTop:
                  items.label == "Total Pembayaran"
                    ? "1px solid #BFBFBF"
                    : "0px",
              }}
            >
              <div
                className={
                  items.label == "Total Pembayaran" ? "fonts700" : "fonts400"
                }
                style={{ marginTop: "10px", marginBottom: "10px" }}
              >
                {items.label}
              </div>
              <div
                className={
                  items["label"] == "Total Pembayaran" ? "fonts700" : "fonts400"
                }
                style={{
                  textAlign: "right",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                Rp{formatterMoney(items.value)}
              </div>
            </div>
          ))}
          {loading && <Loading />}
        </div>
      </div>
      <div style={{ margin: "20px 10px 20px 10px" }}>
        <div className="fonts500" style={{ textAlign: "center" }}>
          "Pesanan yang sudah di pesan, tidak bisa di batalkan"
        </div>
        <div style={{ margin: "20px 10px 0 10px" }}>
          <Button
            loading={loadingPembayaran}
            onClick={onOrder}
            color="#fff"
            backgroundColor="#5451D6"
          >
            Order
          </Button>
        </div>
      </div>
    </div>
  );
}
